export default __webpack_public_path__ + "static/media/trashIconBlack.72436aef.svg";